import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  reportName: Yup.string()
    .required('Report name is required')
    .max(50, 'Report name is maximum 50 characters'),
  emailList: Yup.string().required('Email list is required'),
  period: Yup.string().required('Period is required'),
  typeIds: Yup.array().required('Please choose at least 1 sensor type'),
});
